import { Routes } from '@angular/router';
import { 
  canCreateArticleGuard, 
  canEditArticleGuard, 
  canCreateCategoryGuard, 
  canEditCategoryGuard 
} from './guards/permission.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadComponent: () => 
      import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'categories',
    loadComponent: () => 
      import('./components/categories-browse/categories-browse.component').then(m => m.CategoriesBrowseComponent)
  },
  {
    path: 'articles',
    loadComponent: () => 
      import('./components/articles-browse/articles-browse.component').then(m => m.ArticlesBrowseComponent)
  },
  {
    path: 'article/new',
    loadComponent: () => 
      import('./components/article-editor/article-editor.component').then(m => m.ArticleEditorComponent),
    canActivate: [canCreateArticleGuard]
  },
  {
    path: 'article/:id',
    loadComponent: () => 
      import('./components/article-detail/article-detail.component').then(m => m.ArticleDetailComponent)
  },
  {
    path: 'article/:id/edit',
    loadComponent: () => 
      import('./components/article-editor/article-editor.component').then(m => m.ArticleEditorComponent),
    canActivate: [canEditArticleGuard]
  },
  {
    path: 'category/new',
    loadComponent: () => 
      import('./components/category-editor/category-editor.component').then(m => m.CategoryEditorComponent),
    canActivate: [canCreateCategoryGuard]
  },
  {
    path: 'category/:id',
    loadComponent: () => 
      import('./components/category-view/category-view.component').then(m => m.CategoryViewComponent)
  },
  {
    path: 'category/:id/edit',
    loadComponent: () => 
      import('./components/category-editor/category-editor.component').then(m => m.CategoryEditorComponent),
    canActivate: [canEditCategoryGuard]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
